import posthog from 'posthog-js';

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY;
const enabled = Boolean(POSTHOG_KEY);

export function initAnalytics() {
    if (!enabled) return;
    posthog.init(POSTHOG_KEY, {
        api_host: 'https://eu.i.posthog.com',
        // Anonymous visitors don't get a person profile; only logged-in users do.
        person_profiles: 'identified_only',
        capture_pageview: 'history_change',
        autocapture: false,
        // Session replay is already covered by Clarity and Sentry.
        disable_session_recording: true,
    });
}

export function identifyUser(userId) {
    if (!enabled || posthog.get_distinct_id() === userId) return;
    posthog.identify(userId);
}

export function resetUser() {
    if (enabled) posthog.reset();
}

export function track(event, properties) {
    if (enabled) posthog.capture(event, properties);
}
